import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3cd78607"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3cd78607&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cd78607')) {
      api.createRecord('3cd78607', component.options)
    } else {
      api.reload('3cd78607', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3cd78607", function () {
      api.rerender('3cd78607', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WaterMark/index.vue"
export default component.exports